export default __webpack_public_path__ + "static/photoelectric10-d4945333d57e01c9d4317d1f363de409.png";